import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, watch } from 'vue';
import type { ComponentPublicInstance } from 'vue';
import { closeModalsOnNavigation } from './functions';
import './style.css';
import { modals } from './composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalsContainer',
  props: {
    loader: null,
    routePath: null
  },
  setup(__props: any) {

const props = __props as {
    loader: (path: string) => ComponentPublicInstance
    routePath: string
};



// TODO replace with loader function
const supportedModals = {
    ViewSegments: defineAsyncComponent(() => import('@/2/components/modals/ViewSegments.vue')),
};

watch(() => props.routePath, () => {
    closeModalsOnNavigation(modals);
});

return { __sfc: true,props, supportedModals, modals }
}

})